import { render, staticRenderFns } from "./AppPath.vue?vue&type=template&id=48014dff&scoped=true&"
import script from "./AppPath.vue?vue&type=script&lang=js&"
export * from "./AppPath.vue?vue&type=script&lang=js&"
import style0 from "./AppPath.vue?vue&type=style&index=0&id=48014dff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48014dff",
  null
  
)

export default component.exports